
    import I18n from 'i18nObj';
    
      import 'translations/conferences.concluded_conference';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('conferences.concluded_conference');
  